import { useQuery } from "@tanstack/react-query";

import { shop } from "@/api/shop";
import { ProductCard } from "@/components/ProductCard";

export function Catalog() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["shop", "products"],
    queryFn: shop.products,
  });

  return (
    <div>
      {/* hero */}
      <section className="mb-10 rounded-2xl border border-line bg-surface p-8 shadow-card sm:p-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-soft px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-strong">
          Piggy marketplace
        </span>
        <h1 className="mt-4 max-w-2xl text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
          Add-ons & upgrades for your trading
        </h1>
        <p className="mt-3 max-w-xl text-base leading-relaxed text-ink-soft">
          Robots, signals, courses and indicators — purchased once, unlocked instantly
          across the Piggy terminal, web and mobile apps.
        </p>
      </section>

      {isLoading && (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-44 animate-pulse rounded-xl border border-line bg-surface" />
          ))}
        </div>
      )}

      {error && (
        <p className="rounded-xl border border-line bg-surface p-6 text-down">
          Could not load the catalog. Please try again.
        </p>
      )}

      {data && data.products.length === 0 && (
        <p className="rounded-xl border border-line bg-surface p-6 text-ink-mute">
          No products available yet — check back soon.
        </p>
      )}

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {data?.products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </div>
  );
}
